import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchPaymentMethods } from "../../../redux/slices/paymentMethodsSlice";

export default function PaymentMethodSelect(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { data: paymentMethodOptions, status } = useSelector(
    (state) => state.paymentMethods
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchPaymentMethods());
    }
  }, [status, dispatch]);

  return (
    <select {...props} className="form-control cp">
      <option value="">
        {t("restaurant.report.choosePaymentMethod")}
      </option>

      {paymentMethodOptions.map((item) => (
        <option key={item._id} value={item._id}>
          {item.payment_type}
        </option>
      ))}
    </select>
  );
}